import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, Download } from "lucide-react";
import { vendorsApi } from "@/lib/api";
import { isImageFile, isPdfFile } from "@/lib/fileHelpers";

export function DocumentPreviewDialog({ vendorId, doc, onClose, onDownload }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);
  const previewable = doc && (isImageFile(doc.original_filename) || isPdfFile(doc.original_filename));

  useEffect(() => {
    if (!doc || !previewable) return undefined;
    let objectUrl;
    setUrl(null);
    setError(false);
    vendorsApi.downloadDocument(vendorId, doc.id)
      .then((res) => {
        const type = isPdfFile(doc.original_filename) ? "application/pdf" : doc.content_type;
        objectUrl = URL.createObjectURL(new Blob([res.data], { type }));
        setUrl(objectUrl);
      })
      .catch(() => setError(true));
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, [doc, vendorId, previewable]);

  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl w-[95vw]" data-testid="vendor-doc-preview-dialog">
        <DialogHeader><DialogTitle className="pr-8 truncate">{doc?.title}</DialogTitle></DialogHeader>
        <div className="min-h-[50vh] flex items-center justify-center bg-muted/40 rounded-lg overflow-hidden">
          {!previewable ? (
            <div className="text-center space-y-3 p-6">
              <p className="text-sm text-muted-foreground">Für Word- und Excel-Dateien ist keine Vorschau verfügbar.</p>
              <Button onClick={() => onDownload(doc)} data-testid="vendor-doc-preview-download"><Download className="w-4 h-4 mr-1.5" />Herunterladen</Button>
            </div>
          ) : error ? (
            <p className="text-sm text-destructive">Vorschau konnte nicht geladen werden.</p>
          ) : !url ? (
            <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
          ) : isPdfFile(doc.original_filename) ? (
            <iframe src={url} title={doc.title} className="w-full h-[70vh] border-0" data-testid="vendor-doc-preview-pdf" />
          ) : (
            <img src={url} alt={doc.title} className="max-h-[70vh] object-contain" data-testid="vendor-doc-preview-img" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
